import { useCallback } from 'react'

import { formatUsd, getFormattedMoney, getFormattedPercentage, Money } from '@/shared/libs/money'

import { useMarket } from './MarketContext'

export function useFormatMoney() {
  const { market } = useMarket()

  const formatMoney = useCallback(
    <TMoney extends Money>(money: TMoney | undefined | null, negative = false) =>
      getFormattedMoney(money, negative, market.locale),
    [market.locale],
  )

  const formatPercentage = useCallback(
    (percentage: number) => getFormattedPercentage(percentage, market.locale),
    [market.locale],
  )

  // All storefront prices are USD (see docs/checkout/stripe-checkout.md).
  return { formatMoney, formatUsd, formatPercentage }
}
